import { useState } from "react";
import { Gavel } from "lucide-react";
import { InquiryDialog } from "@/components/InquiryDialog";

export const ActsSection = ({ acts }) => (
  <section className="mx-auto max-w-6xl px-5 py-20 text-center sm:px-8" data-testid="acts-section">
    <h2 className="font-display text-3xl text-[#1F1B17] sm:text-4xl">One Night. {acts.length === 4 ? "Four" : acts.length} Acts.</h2>
    <div className="mt-10 grid gap-4 text-left sm:grid-cols-2 lg:grid-cols-4">
      {acts.map((a, i) => (
        <div key={i} className="rounded-lg border border-[#E5DACA] bg-white p-6 transition-shadow duration-300 hover:shadow-[0_12px_30px_-14px_rgba(60,40,10,0.3)]" data-testid={`act-card-${i}`}>
          <span className="font-display text-3xl text-[#C9A24B]">{a.numeral}</span>
          <h3 className="mt-2 font-display text-xl text-[#1F1B17]">{a.title}</h3>
          <p className="mt-2 text-sm leading-relaxed text-[#6B6157]">{a.text}</p>
        </div>
      ))}
    </div>
  </section>
);

export const VerdictSection = ({ verdict }) => (
  <section className="bg-[#141210] text-white" data-testid="verdict-section">
    <div className="mx-auto max-w-2xl px-5 py-20 text-center">
      <Gavel className="mx-auto h-7 w-7 text-[#D9B864]" />
      <h2 className="mt-4 font-display text-3xl sm:text-4xl">{verdict.title}</h2>
      <p className="mt-3 text-[#E9E1D4]">{verdict.intro}</p>
      <ul className="mt-8 space-y-3 text-left">
        {verdict.points.map((p, i) => (
          <li key={i} className="flex gap-3 rounded-md border border-[#C9A24B]/30 bg-white/[0.03] px-5 py-4 text-[#E9E1D4]"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#D9B864]" />{p}</li>
        ))}
      </ul>
      <a href="#book" data-testid="verdict-reserve-button" className="mt-8 inline-block rounded border border-[#C9A24B] px-8 py-4 text-xs font-extrabold uppercase tracking-[0.2em] text-[#F3DDA4] transition-colors hover:bg-[#C9A24B] hover:text-[#141210]">Reserve your seat</a>
    </div>
  </section>
);

export const PrivateSection = ({ options, eventSlug }) => {
  const [open, setOpen] = useState(null);
  return (
    <section className="mx-auto max-w-4xl px-5 py-20 text-center sm:px-8" data-testid="private-section">
      <p className="eyebrow">For your group only</p>
      <h2 className="mt-3 font-display text-3xl text-[#1F1B17] sm:text-4xl">Book a private evening.</h2>
      <div className="mt-10 grid gap-4 text-left md:grid-cols-2">
        {options.map((o, i) => (
          <div key={i} className="flex flex-col justify-between rounded-lg border border-[#E5DACA] bg-white p-6">
            <div>
              <h3 className="font-display text-xl text-[#1F1B17]">{o.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-[#6B6157]">{o.text}</p>
            </div>
            <button type="button" onClick={() => setOpen(o.title)} data-testid={`private-quote-button-${i}`}
              className="mt-6 self-start rounded border border-[#1F1B17] px-5 py-3 text-[11px] font-extrabold uppercase tracking-[0.18em] text-[#1F1B17] transition-colors hover:bg-[#141210] hover:text-[#F3DDA4]">
              Request a quote
            </button>
          </div>
        ))}
      </div>
      <InquiryDialog open={!!open} onOpenChange={(v) => !v && setOpen(null)} option={open || ""} eventSlug={eventSlug} />
    </section>
  );
};
